<template>
  <div :class="`tool-index-menu__nivel${level}`">
    <div :class="`tool-index-menu__item nivel${level}`">
      <span 
        class="menu-text" 
        @click="$emit('menu-click', item)"
      >
        {{ item.displayText }}
      </span>
      <span 
        v-if="hasSubitems"
        class="expand-icon" 
        @click="$emit('toggle-expand', item.id)"
      >
        {{ isExpanded ? '&#9660;' : '&#9658;' }}
      </span>
    </div>

    <div 
      v-if="isExpanded && hasSubitems" 
      class="tool-index-menu__subitems"
    >
      <ToolMenuItem
        v-for="subitem in item.subferramentas"
        :key="subitem.id"
        :item="subitem"
        :expanded-items="expandedItems"
        :level="level + 1"
        @toggle-expand="$emit('toggle-expand', $event)"
        @menu-click="$emit('menu-click', $event)"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'ToolMenuItem',
  emits: ['toggle-expand', 'menu-click'],
  props: {
    item: {
      type: Object,
      required: true
    },
    expandedItems: {
      type: Set,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const isExpanded = computed(() => 
      props.expandedItems.has(props.item.id)
    );

    const hasSubitems = computed(() => 
      props.item.subferramentas && props.item.subferramentas.length > 0
    );

    return {
      isExpanded,
      hasSubitems
    };
  }
};
</script>

<style scoped>
@import './style.css';
</style>